import Ajax from 'js/utils/ajax/ajax';

import { ApiServiceSupplier } from 'src/interfaces/interfaces.generated';

export const editServiceSupplier = (
  serviceSupplier: ApiServiceSupplier,
  serviceSupplierId: number
): Promise<any> => Ajax.patch(`/shops/v1/servicesuppliers/${serviceSupplierId}`, serviceSupplier);
